'use strict';

const stripIndent = require('strip-indent');
const indentString = require('indent-string');
module.exports = function (string) {
  let count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let options = arguments.length > 2 ? arguments[2] : undefined;
  return indentString(stripIndent(string), count, options);
};